import { site } from '../site'

const outline =
  'btn text-sm rounded-none border border-black bg-transparent text-black hover:bg-transparent'
const solid =
  'btn text-sm rounded-none border-0 bg-black text-white hover:bg-black'

function ContactButtons({ className = '', children }) {
  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {children ?? (
        <a
          className={outline}
          href={site.resumeUrl}
          target='_blank'
          rel='noreferrer noopener'
        >
          view my resume
        </a>
      )}
      <a className={solid} href={`mailto:${site.email}`}>
        message me
      </a>
    </div>
  )
}

export { outline, solid }
export default ContactButtons
